<template>
  <tr>
    <td id="name" class="sticky" nowrap>
      <!-- <router-link
        :to="{
          name: 'candidate_id',
          params: {
            candidate_id: recentPlacement.candidate_id,
            candidate_name: recentPlacement.candidate,
          },
        }"
      >
        {{ recentPlacement.candidate_first_name }}
        {{ recentPlacement.candidate_last_name }}
      </router-link> -->

      <popper
        trigger="hover"
        :options="{
          placement: 'top',
          modifiers: { offset: { offset: '0,10px' } },
        }"
      >
        <div class="popper">
          {{ recentPlacement.candidate_first_name }}
          {{ recentPlacement.candidate_last_name }}
        </div>
        <div slot="reference" class="truncate-item">
          <router-link
            style="text-decoration: none"
            :to="{ name: 'candidate_id', params: { candidate_id: recentPlacement.candidate_id } }"
          >
            {{ recentPlacement.candidate_first_name }}
            {{ recentPlacement.candidate_last_name }}
          </router-link>
        </div>
      </popper>
    </td>
    <td id="job">
      <popper
        trigger="hover"
        :options="{
          placement: 'top',
          modifiers: { offset: { offset: '0,10px' } },
        }"
      >
        <div class="popper">
          {{ recentPlacement.job }}
        </div>
        <div slot="reference" class="truncate-item">
          <router-link
            style="text-decoration: none"
            :to="{ name: 'job_uuid', params: { job_uuid: recentPlacement.job_id } }"
            >{{ recentPlacement.job }}</router-link
          >
        </div>
      </popper>
    </td>
    <td id="employer">
      <router-link
        :to="{
          name: 'employer_id',
          params: {
            employer_id: recentPlacement.employer_id,
            employer_name: recentPlacement.employer,
          },
        }"
      >
        {{ recentPlacement.employer }}
      </router-link>
    </td>
    <td id="location" nowrap>
      {{ recentPlacement.location.city }}, {{ recentPlacement.location.country }}
    </td>
    <td id="hired" nowrap>
      <popper
        trigger="hover"
        :options="{
          placement: 'top',
          modifiers: { offset: { offset: '-60,10px' } },
        }"
      >
        <div class="popper">
          {{
            recentPlacement.hired_date
              | formatDate({
                format: getUserProfile.format_date,
                timezone: getUserProfile.timezone,
                hasHourAndMinutes: true,
              })
          }}
        </div>
        <div slot="reference">
          {{
            recentPlacement.hired_date
              | formatDate({
                format: getUserProfile.format_date,
                timezone: getUserProfile.timezone,
                hasHourAndMinutes: false,
              })
          }}
        </div>
      </popper>
    </td>
    <td id="recruiter">
      <popper
        trigger="hover"
        :options="{
          placement: 'top',
          modifiers: { offset: { offset: '0,10px' } },
        }"
      >
        <div class="popper">
          {{ recentPlacement.source.description }}
        </div>
        <div slot="reference">{{ recentPlacement.source.source_name }}</div>
      </popper>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    recentPlacement: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters(['getUserProfile']),
  },
  mounted() {
    // console.log(this.getUserProfile.format_date);
  },
};
</script>
